import type { SVGProps } from 'react';

const CloseFilledIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 12 12" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M.22.22a.752.752 0 011.064 0L6 4.936 10.716.22a.752.752 0 01.98-.073l.084.073a.752.752 0 010 1.064L7.064 6l4.716 4.716a.752.752 0 01.073.98l-.073.084a.752.752 0 01-1.064 0L6 7.064 1.284 11.78a.752.752 0 01-.98.073L.22 11.78a.752.752 0 010-1.064L4.936 6 .22 1.284a.752.752 0 01-.073-.98z"
            fill="currentColor"
        />
    </svg>
);

export default CloseFilledIcon;
